import { Form, Row, Col } from "react-bootstrap";
import { useFormContext, useWatch } from "react-hook-form";

import AutoCompleteSearch from "../../../../../Insurance/AutoCompleteSearch";
import ContactPanelForEditPopups from "../../../../../TreatmentPage/components/ContactPanelForEditPopups";
import { formatPhoneNumber } from "../../../../../../Utils/helper";

import StateSelect from "./StateSelect";

export const capitalize = (v) =>
  typeof v === "string" && v.length > 0 ? v.charAt(0).toUpperCase() + v.slice(1) : v;

export const registerCapitalized = (register, setValue, name, options = {}) => ({
  ...register(name, {
    ...options,
    onChange: (e) => {
      const v = e.target.value;
      if (v.length > 0) {
        setValue(name, capitalize(v), { shouldValidate: false, shouldDirty: true });
      }
      options.onChange?.(e);
    },
  }),
});

const InsurancePartyFieldset = ({
  prefix,
  entityId,
  clear,
  panelName,
  searchPlaceholder,
  search,
  statesData,
  renderNameRow,
  computeDisplayName,
  dynamicLabel,
  panelStyle,
}) => {
  const { register, control, setValue } = useFormContext();
  const f = (field) => `insurance.${entityId}.${prefix}_${field}`;
  const watched = useWatch({
    control,
    name: [
      f("address1"),
      f("address2"),
      f("email"),
      f("phone"),
      f("city"),
      f("state"),
      f("zip"),
      f("fax"),
      f("extension"),
      f("website"),
    ],
  });
  const [address1, address2, email, phone, city, state, zip, fax, ext, website] = watched;

  return (
    <>
      <Row className="mx-0">
        <Col md={12} className="p-l-5 p-r-5">
          <Form.Control
            type="text"
            placeholder={searchPlaceholder}
            className="custom-margin-top custom-margin-bottom height-25 p-0 p-l-5 rounded-0"
            onKeyUp={search.onSearchKeyUp}
          />
          {search.results.length > 0 && (
            <AutoCompleteSearch
              searchedInsurances={search.results}
              selectedInsurance={search.applySelection}
              isCompany={prefix === "company"}
              isAdjuster={prefix === "adjuster"}
            />
          )}
        </Col>
      </Row>

      <Row className="mx-0 p-l-5">
        <div style={panelStyle}>
          <ContactPanelForEditPopups
            panel_name={panelName}
            className="m-b-5"
            dynamic_label={dynamicLabel}
            name={computeDisplayName()}
            address1={address1}
            address2={address2}
            email={email}
            phone_number={phone}
            city={city}
            state={state}
            zip_code={zip}
            fax_number={fax}
            ext={ext}
            websiteURL={website}
            buttonData={[]}
            pageName="Case Loans"
          />
        </div>

        <Col md="auto" className="p-0 d-flex-1">
          {renderNameRow(f)}

          <Row className="align-items-center custom-margin-bottom mx-0">
            <div className="d-flex-1 p-r-5 p-l-0">
              <Form.Control
                type="text"
                className="height-25 p-0 p-l-5 rounded-0"
                placeholder="Address 1"
                {...registerCapitalized(register, setValue, f("address1"))}
              />
            </div>
            <div className="d-flex-1 p-l-0 p-r-5">
              <Form.Control
                type="text"
                className="height-25 p-0 p-l-5 rounded-0"
                placeholder="Address 2"
                {...registerCapitalized(register, setValue, f("address2"))}
              />
            </div>
          </Row>

          <Row className="align-items-center custom-margin-bottom mx-0">
            <div className="d-flex-1 p-l-0 p-r-5">
              <Form.Control
                type="text"
                placeholder="City"
                className="form-control height-25 p-0 p-l-5 rounded-0"
                {...registerCapitalized(register, setValue, f("city"))}
              />
            </div>
            <StateSelect name={f("state")} statesData={statesData} />
            <div
              style={{
                maxWidth: "90px",
              }}
              className="d-flex-1 p-r-5"
            >
              <Form.Control
                type="text"
                placeholder="Zip"
                className="height-25 p-0 p-l-5 rounded-0"
                {...register(f("zip"))}
              />
            </div>
          </Row>

          <Row className="align-items-center custom-margin-bottom mx-0">
            <div className="d-flex-1 p-r-5 p-l-0">
              <Form.Control
                type="text"
                placeholder="(###) ###-####"
                className="height-25 p-0 p-l-5 rounded-0"
                {...register(f("phone"), {
                  onChange: (e) => setValue(f("phone"), formatPhoneNumber(e.target.value)),
                })}
              />
            </div>
            <div
              style={{
                maxWidth: "90px",
              }}
              className="d-flex-1 p-l-0 p-r-5"
            >
              <Form.Control
                type="text"
                placeholder="Extension"
                className="form-control height-25 p-0 p-l-5 rounded-0"
                {...register(f("extension"), {
                  onChange: (e) => setValue(f("extension"), e.target.value.replace(/[^0-9]/g, "")),
                })}
              />
            </div>
            <div className="d-flex-1 p-l-0 p-r-5">
              <Form.Control
                type="text"
                placeholder="(###) ###-#### - fax"
                className="height-25 p-0 p-l-5 rounded-0"
                {...register(f("fax"), {
                  onChange: (e) => setValue(f("fax"), formatPhoneNumber(e.target.value)),
                })}
              />
            </div>
          </Row>

          <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
            <Form.Control
              type="text"
              className="height-25 p-0 p-l-5 rounded-0"
              placeholder="Email"
              {...register(f("email"))}
            />
          </div>

          <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
            <Form.Control
              type="text"
              className="height-25 p-0 p-l-5 rounded-0"
              placeholder="Website"
              {...register(f("website"))}
            />
          </div>

          <div className="d-flex p-r-5 align-items-center justify-content-end">
            <button
              type="button"
              onClick={() => clear()}
              style={{
                cursor: "pointer",
                fontSize: 14,
                lineHeight: 1,
                userSelect: "none",
                minWidth: "80px",
              }}
              className="btn btn-primary height-25 p-0"
            >
              Clear
            </button>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default InsurancePartyFieldset;
